import { render, staticRenderFns } from "./EpcArrayBrussels.vue?vue&type=template&id=3c208ae3&scoped=true&"
import script from "./EpcArrayBrussels.vue?vue&type=script&lang=js&"
export * from "./EpcArrayBrussels.vue?vue&type=script&lang=js&"
import style0 from "./EpcArrayBrussels.vue?vue&type=style&index=0&id=3c208ae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c208ae3",
  null
  
)

export default component.exports